module.exports = __webpack_public_path__ + "static/media/podcast.73b0b2f4.svg";